export default __webpack_public_path__ + "static/media/Dr._Patricia_Gestoso_AHV_In_Moms_We_Trust.6f27572b.jpg";